import { FC } from 'react'
import InfiniteScroll from 'react-infinite-scroll-component'
import CenteredLoadingAnimation from '../../../__legacy__/components/core/CenteredLoadingAnimation'
import { RedirectRow } from '../components'
import { RedirectTable } from '../primitives'
import { useRedirects } from '../queries'

export const RedirectsTableRows: FC = () => {
  const perPage = 50
  const { isLoading, data, fetchNextPage, hasNextPage } = useRedirects({ perPage })
  const noResults = data?.pages?.[0].meta.total === 0

  if (isLoading) {
    return <CenteredLoadingAnimation />
  }

  if (noResults) {
    return <RedirectTable.NoResultsText size="16">No results</RedirectTable.NoResultsText>
  }

  return (
    <InfiniteScroll
      loader={<CenteredLoadingAnimation />}
      dataLength={data?.pages?.length * perPage}
      next={fetchNextPage}
      hasMore={hasNextPage}
      style={{ overflow: 'visible' }}
    >
      {data.pages?.flatMap((page) =>
        page.data.map((redirect) => <RedirectRow key={redirect.id} redirect={redirect} />)
      )}
    </InfiniteScroll>
  )
}
